import React, { useState, useEffect } from 'react';
import './../App.css'; // Assuming you have a CSS file for styling
import logo from './../assets/logo_150.svg'; // Import logo.svg from the assets folder
import Header from './../components/Header';
import Footer from '../components/Footer';

const AboutPage = () => {
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const position = window.pageYOffset;
            setScrollPosition(position);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className="app">
            <Header scrolled={scrollPosition > 0} />
            <div className="content article">
                    <h1>О нас</h1>
                    <p>
                        Привет! Мы команда из людей, которые решили улучшить то, как мы смотрим аниме в России<br/>
                        Мы разработали  сайт, который предоставляет информацию о популярных аниме, а также позволяет вам смотреть их онлайн.<br/>
                        Надеемся, у нас получается сделать Вашу жизнь чуточку лучше. чмок<br/><br/>
                        Следите за нами в социальных сетях, если у вас есть вопросы или предложения<br/>
                        
                    </p>
                </div>
            <Footer />
        </div>
    );
};

export default AboutPage;
